var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatDiaryViewBreedingDates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#57b3ff;}.cls-2{fill:#0072b2;}.cls-3{fill:#ccc;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_progesterone_view_mating"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.21,62.14c-36.65,0-66.35,26.72-66.35,59.68V539.58c0,33,29.7,59.68,66.35,59.68H534.7c36.66,0,66.35-26.7,66.35-59.68V121.82c0-33-29.69-59.68-66.35-59.68H70.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.21,62.14C33.56,62.14,3.86,89,3.86,121.82v89.52H601.05V121.82c0-32.82-29.69-59.68-66.35-59.68H70.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.33,2.46A29.84,29.84,0,0,0,81.49,32.3v89.52a29.84,29.84,0,1,0,59.68,0V32.3A29.84,29.84,0,0,0,111.33,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.37,2.46c-16.47,0-29.84,11.94-29.84,29.84v89.52c0,14.92,13.37,29.84,29.84,29.84s29.84-14.92,29.84-29.84V32.3C515.21,14.4,501.84,2.46,485.37,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.59,484.12a93.36,93.36,0,1,1,93.35-93.36A93.46,93.46,0,0,1,289.59,484.12Zm0-150.19a56.83,56.83,0,1,0,56.82,56.83A56.89,56.89,0,0,0,289.59,333.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 331.08,
    y: 293.22,
    width: 81.98,
    height: 36.53,
    transform: "translate(-111.28 354.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,292.09H350.41a18.27,18.27,0,1,1,0-36.53H411a18.27,18.27,0,0,1,0,36.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,352.71a18.27,18.27,0,0,1-18.27-18.27V273.82a18.27,18.27,0,0,1,36.53,0v60.62A18.27,18.27,0,0,1,411,352.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.59,559.92a18.27,18.27,0,0,1-18.27-18.27V471.71a18.27,18.27,0,1,1,36.53,0v69.94A18.27,18.27,0,0,1,289.59,559.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.36,536.6H259.74a18.27,18.27,0,0,1,0-36.53h60.62a18.27,18.27,0,1,1,0,36.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryViewBreedingDates);
export default __webpack_public_path__ + "static/media/heat_diary_view_breeding_dates.4731050c4c26c486224e03e7e1a06e69.svg";
export { ForwardRef as ReactComponent };